<template>
  <div>
    <vxe-grid
      ref="table"
      round
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:colorInfo="{ row }">
        <div>{{ row.fabricColorTitle }}</div>
        <div>数量：{{ row.requestQuantity }}</div>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{}"> </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    mainType: {
      type: String,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    params: {
      default: null,
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
      // tableHeight: 375,
      tableData: [],
      tablePage: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      tableColumn: [
        {
          field: 'fabricColorTitle',
          minWidth: 300,
          title: '面料颜色及数量',
          slots: { default: 'colorInfo' },
        },
      ],
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
    }
  },
  methods: {
    load(params) {
      this.loading = true
      this.$api
        .fabricRequestColorListApi({
          ...(params || this.params),
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTableData() {
      return this.tableData
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
</style>
